import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.features.list-report-access-grants.ReportAccessGrantListPresenter`

export default defineMessages({
  fetchErrorToastTitle: {
    id: `${scope}.fetchErrorToastTitle`,
    defaultMessage: 'Error',
  },
  fetchErrorToastMessage: {
    id: `${scope}.fetchErrorToastMessage`,
    defaultMessage: 'Unable to load report access users. Please try again.',
  },
})
